import { render, staticRenderFns } from "./CardOrderMobile.vue?vue&type=template&id=4caf4824&scoped=true"
import script from "./CardOrderMobile.vue?vue&type=script&lang=js"
export * from "./CardOrderMobile.vue?vue&type=script&lang=js"
import style0 from "./CardOrderMobile.vue?vue&type=style&index=0&id=4caf4824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caf4824",
  null
  
)

export default component.exports